var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getshowModule().length > 0)?_c('div',{staticClass:"warning-wrapper"},_vm._l((_vm.getshowModule()),function(item,index){return _c('FTItem',{key:index,staticClass:"wrappertop",attrs:{"content":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }